"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('pineapple', true, function (props) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.5 14.5C20 14 20 13.1492 20 11C20 7.13401 24 4 24 4C24 4 27 7.13401 27 11C27 12.9224 27 14 26.5 14.5",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 17.0002C15.7891 14.082 12.8623 10.4327 11 9.00018C16.411 7.98561 20.7736 11.3008 23 14.0002",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 16C31.4519 13.303 34.3038 10.3047 36 8.99997C30.3567 7.94185 26.1286 11.2611 24 14",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.7254 17.3742C16.1755 17.8607 15.5999 18.4006 15.0005 19C10.8099 23.1905 10.1023 30.864 10.0028 34.2804C9.96939 35.4298 9.97739 36.6023 10.4118 37.6669C10.8787 38.811 11.8749 40.4055 14.0008 42C18.0006 45 30.0006 45 34.0003 42C36.1167 40.4127 37.1132 38.8254 37.5824 37.6824C38.0234 36.6083 38.0311 35.4238 37.9969 34.2632C37.8958 30.8382 37.184 23.1834 33.0006 19C32.4011 18.4006 31.8254 17.8605 31.2754 17.374C27.0168 13.6072 20.984 13.6074 16.7254 17.3742Z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M32 18L11 29",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 18L37 29",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35 41L11 27",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 27L13 41",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;